import React, { useEffect } from "react";
import { useObserver } from "mobx-react";
import { useState } from "react";
import { useStores } from "../../store";
import { AiFillCloseCircle, AiFillMail } from "react-icons/ai";
import { AiOutlineCopy } from "react-icons/ai";
import image from "../../assests/image.png";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import { FaLinkedin } from "react-icons/fa";
import { FaSquareWhatsapp, FaSquareXTwitter } from "react-icons/fa6";
export default function ReferAndEarn({ popUpInitialValue, handlePopup }) {
  const { PopupStore, UserStore } = useStores();
  const [user, setUser] = useState();
  useEffect(() => {
    const userDetail = localStorage.getItem("user");
    setUser(JSON.parse(userDetail));
    console.log(userDetail);
  }, []);

  const closeThisPopUP = () => {
    PopupStore.setGetMoreCredits(false);
    handlePopup();
  };
  const showGateWay = () => {
    closeThisPopUP();
    PopupStore.setPaymentGateway(true);
  };

  const showRedeemCoupon = () => {
    closeThisPopUP();
    PopupStore.setRedeemCoupon(true);
  };

  return useObserver(() => (
    <>
      {popUpInitialValue ? (
        <div
          onClick={closeThisPopUP}
          className="fixed w-screen h-screen gil-reg z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded items-center md:w-[30%] lg:w-[40%] w-[90%] h-[75%] md:h-[95%] lg:h-[95%] m-auto shadow-lg overflow-y-auto no-scrollbar"
          >
            <div className=" flex flex-col justify-center   h-full py-5 w-[100%] md:w-[100%] lg:[100%] border ">
              <AiFillCloseCircle
                className="text-primary absolute text-2xl lg:text-4xl cursor-pointer  top-2 right-2"
                onClick={closeThisPopUP}
              />
              <ReferAndEarnContent />
            </div>
            <div className="w-full px-7 mt-2">
              {/* <input type="url" value={`https://app.reaidy.io?refer=${UserStore.userDetails?.referalCode}`} className="px-3 py-1 border-2 w-[100%] border-grey-700 rounded-xl focus:outline-none" disabled /> */}
            </div>

            {/* <div className="flex flex-col w-full items-start py-10">
                            <div className="flex flex-col items-center  w-[90%] h-full m-auto">
                                <button
                                    // disabled={true}
                                    onClick={showGateWay}
                                    // onClick={() => alert("This feature is under development")}
                                    className=" rounded-xl mt-2 flex items-center justify-center hover:bg-primary bg-primary2 text-lg hover:text-white font-semibold  text-primary py-2 px-4 w-full"
                                >
                                    <AiOutlineCreditCard className="mr-4 underline text-2xl" />
                                    Purchase Credits
                                </button>
                            </div>

                            <div className="flex flex-col items-center  w-[90%] h-full m-auto">
                                <button
                                    onClick={showRedeemCoupon}
                                    className=" rounded-xl mt-2 flex items-center justify-center hover:bg-primary bg-primary2 text-lg hover:text-white font-semibold  text-primary py-2 px-4 w-full"
                                >
                                    <IoTicketOutline className="mr-4 underline text-2xl" />
                                    
                                </button>
                            </div>
                        </div> */}
          </div>
        </div>
      ) : null}
    </>
  ));
}

export function ReferAndEarnContent() {
  const { UserStore } = useStores();

  const [user, setUser] = useState();

  useEffect(() => {
    const userDetail = localStorage.getItem("user");
    setUser(JSON.parse(userDetail));
    console.log(userDetail);
  }, []);
  const [textToCopy, setTextToCopy] = useState(
    `https://${getDomainForWhiteLabeling()}?refer=${
      UserStore.userDetails?.referalCode
    }`
  );

  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    alert("link copied !!!");
  };

  const handleChangeAccount = () => {
    // Retrieve the user object from localStorage
    const user = JSON.parse(localStorage.getItem("user"));
    console.log("Original User:", user);

    // Prompt the user to enter a new ID
    const newId = window.prompt("Please enter new ID:");

    // Validate the new ID
    if (
      newId &&
      newId.length === user._id.length &&
      /^[a-fA-F0-9]+$/.test(newId)
    ) {
      // Update the _id property in the user object
      user._id = newId;

      // Save the updated user object back to localStorage
      localStorage.setItem("user", JSON.stringify(user));

      console.log("Updated User:", user);
    } else {
      // Handle invalid ID case
      alert(
        "Invalid ID. Please ensure it is a 24-character hexadecimal string."
      );
    }
  };

  const shareOnWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(textToCopy)}`;
    window.open(whatsappUrl, "_blank");
  };

  const shareOnTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      textToCopy
    )}`;
    window.open(twitterUrl, "_blank");
  };

  const shareOnEmail = () => {
    const emailSub = "Share link";
    const email = `${textToCopy}`;
    const emailUrl = `mailto:?subject=${encodeURIComponent(
      emailSub
    )}&body=${encodeURIComponent(email)}`;
    window.open(emailUrl, "_blank");
  };

  const shareOnLinkedIn = () => {
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      textToCopy
    )}`;
    window.open(linkedInUrl, "_blank");
  };

  return (
    <>
      {/* <div className="absolute top-24 md:relative md:top-0 px-5 md:px-20 lg:px-10 lg:text-3xl">
       <p className="font-bold opacity-90 text-2xl text-primary lg:text-4xl lg:pt-5 ">
          Refer a friend
        </p>
        <p className="font-extrabold  mt-2 lg:py-10">
          <span className="opacity-75 py-8 ">
            {" "}
            Refer your friends and both of you get{" "}
          </span>{" "}
          <br /> <span className="opacity-95">50</span>{" "}
          <span className="opacity-75">credit points </span>
        </p>
       </div> */}
      <div className="flex justify-center pt-6">
        <img
          src={image}
          alt="referal"
          className=" object-cover w-[90%] lg:w-[80%]"
          onDoubleClick={handleChangeAccount}
        />
      </div>
      {/* <div className=" px-7 mt-3 ">
        <div className=" w-full px-7 py-3">
          <div className="flex justify-around space-x-2 mt-3">
            <div className=" border w-24 md:w-[30%] lg:w-[30%] py-4 rounded-xl ">
              <p className="font-extrabold text-center text-2xl">-</p>
              <p className="font-bold opacity-80 text-center text-sm lg:text-3xl">
                Earned
              </p>
            </div>
            <div className=" border w-24 md:w-[30%] lg:w-[30%] py-4 rounded-xl">
              <p className="font-extrabold text-center text-2xl">-</p>
              <p className="font-bold opacity-80 text-center text-sm lg:text-3xl">
                Invited
              </p>
            </div>
            <div className=" border w-24 md:w-[30%] lg:w-[30%] py-4 rounded-xl">
              <p className="font-extrabold text-center text-2xl">-</p>
              <p className="font-bold opacity-80 text-center text-sm lg:text-3xl">
                Registered
              </p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="mt-5 md:px-10 lg:px-20 lg:text-3xl">
        <p className="flex font-bold opacity-90 text-2xl text-primary lg:text-4xl lg:pt-6 px-2 ">
          Refer a friend
        </p>

        <p className="font-medium px-2 mt-2 lg:py-10">
          <span className="opacity-75 py-8 ">
            {" "}
            Refer your friends and both of you get{" "}
          </span>{" "}
          <br /> <span className="opacity-95">50</span>{" "}
          <span className="opacity-75">credit points </span>
        </p>
      </div>

      <div className=" px-2 mt-1 ">
        <div className=" w-[100%] md:px-7 py-3">
          <div className="flex justify-around space-x-2 mt-3">
            <div className=" border w-32 md:w-[30%] lg:w-[30%] py-4 rounded-xl ">
              <p className="font-semibold text-center text-2xl">
                {user?.refferTo.length * 50}
              </p>
              <p className="font-medium opacity-80 text-center text-sm lg:text-3xl">
                Earned
              </p>
            </div>
            <div className=" border w-32 md:w-[30%] lg:w-[30%] py-4 rounded-xl">
              <p className="font-semibold text-center text-2xl">
                {user?.refferTo.length}
              </p>
              <p className="font-medium opacity-80 text-center text-sm lg:text-3xl">
                Invited
              </p>
            </div>
            <div className=" border w-32 md:w-[30%] lg:w-[30%] py-4 rounded-xl">
              <p className="font-semibold text-center text-2xl">
                {user?.refferTo.length}
              </p>
              <p className="font-medium opacity-80 text-center text-sm lg:text-3xl">
                Registered
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex space-x-2 md:space-x-2 mx-[1%] md:ml-[10%]">
        <div className="w-[100%] md:w-[73%] flex items-center justify-between text-gray-800 border border-primary bg-white max-w-sm lg:max-w-fit font-mono text-sm py-3 px-4 rounded-full">
          <div class="flex lg:text-2xl lg:w-fit">
            <span id="myInput" className="text-xs">
              https://{getDomainForWhiteLabeling()}?refer=
              {UserStore.userDetails?.referalCode}
            </span>
          </div>
          {/* <span
              class="flex text-gray-800 cursor-pointer w-5 h-5 lg:w-7 lg:h-5 hover:text-gray-400 duration-200"
              onClick={handleCopyClick}
            >
              {" "}
              <AiOutlineCopy className="text-xl active:text-primary lg:text-4xl" />
            </span> */}
        </div>
        <div
          className="flex md:gap-0.5 cursor-pointer items-center justify-center hover:text-gray-400 duration-200"
          onClick={handleCopyClick}
        >
          <span class="flex text-gray-800  w-5 h-5 lg:w-7 lg:h-5 hover:text-gray-400 duration-200">
            {" "}
            <AiOutlineCopy className="text-xl active:text-primary lg:text-4xl" />
          </span>
          {window.innerWidth >= 1000 && (
            <span className="">
              <p>copy</p>
            </span>
          )}
        </div>
        {/* <div className="flex justify-center pr-6 w-full">
            <div className="border bg-primary rounded-full flex justify-center  text-white mt-8 w-[100%]">
              <button className="flex justify-center items-center p-3  md:px-5" onClick={handleCopyClick}>
                <p className="pr-3 md:pr-2 font-medium"> share a friend </p>

                <LuSend></LuSend>
              </button>
            </div>
          </div> */}
      </div>
      <div className="flex justify-center flex-col items-center mt-10">
        <h3 className="mb-2">You can also share the link with</h3>
        <div className="flex flex-row lg:text-4xl mb-2 text-3xl">
          <FaSquareWhatsapp
            className="text-green-500 mx-1 cursor-pointer"
            onClick={shareOnWhatsApp}
          />
          <FaSquareXTwitter
            className="mx-1 cursor-pointer"
            onClick={shareOnTwitter}
          />
          <AiFillMail
            className="text-blue-500 mx-1 cursor-pointer"
            onClick={shareOnEmail}
          />
          <FaLinkedin
            className="text-blue-600 mx-1 cursor-pointer"
            onClick={shareOnLinkedIn}
          />
        </div>
      </div>
      {/* <div className="flex justify-center items-center w-[85%] md:ml-[10%] md:w-[80%]">
        <div className="border bg-primary rounded-full flex justify-center  text-white mt-6 w-[100%]">
          <button
            className="flex justify-center text-lg items-center p-3  md:px-5"
            onClick={handleCopyClick}
          >
            <p className="pr-3 md:pr-2 font-medium"> share a friend </p>

            <LuSend></LuSend>
          </button>
        </div>
      </div> */}
      {/* </div> */}
    </>
  );
}
